// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__11teu","label":"Labeled_label__2lpmJ","divider":"Labeled_divider__1hdsa"};